<template>
    <div class="project">
        <h1 v-if="items" class="blue-grey--text my-5 text-center">총 {{ items.length }} 항목</h1>
        <v-container>

            <!-- serch box -->
            <v-row justify="end">
                <v-col
                    cols="12"
                    sm="6"
                >
                    <NodeDescription :items="filteredItems" />
                    <ContextualRelation :items="filteredItems" />
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                >
                    <v-text-field
                        label="Search"
                        v-model="search"
                        prepend-inner-icon="mdi-magnify"
                    ></v-text-field>
                </v-col>
            </v-row>

            <!-- sort by -->
            <!-- <v-row>
                <v-col cols="12">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            text
                            class="blue-grey--text"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            @click="sortBy('class')"
                        >
                            <v-icon small left>mdi-google-classroom</v-icon>
                            <span>class</span>
                        </v-btn>
                        </template>
                        <span>'class'로 정렬하기</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            text
                            class="blue-grey--text"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            @click="sortBy('hangeul')"
                        >
                            <v-icon small left>mdi-tag-outline</v-icon>
                            <span>hangeul</span>
                        </v-btn>
                        </template>
                        <span>'hangeul'로 정렬하기</span>
                    </v-tooltip>
                </v-col>
            </v-row> -->

            <!-- project status -->
            <FilterNav @filterChange="current = $event" :current="current" />
            <!-- items -->
            <v-card class="mx-3" flat v-for="(item, index) in filteredItems" :key="item.id">
                <SingleProject :item="item" :index="index" />
                <v-divider></v-divider>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import ContextualRelation from '../components/ContextualRelation.vue'
import NodeDescription from '../components/NodeDescription.vue'
import SingleProject from '../components/SingleProject.vue'
import FilterNav from '../components/FilterNav.vue'
import { auth } from '../firebase/init'
import { db } from '../firebase/init'

export default {
    components: { ContextualRelation, NodeDescription, SingleProject, FilterNav },
    name: 'Project',
    data () {
        return {
            user: null,
            item: null,
            search: '', 
            items: [],
            current: 'all'
        }
    },
    methods: {
        sortBy(prop){
            this.items.sort((a, b) => a.nodeDescription[prop] < b.nodeDescription[prop] ? -1 : 1)
        }
    },
    computed: {
        filteredItems(){
            let items = null;
            if(this.current === 'completed') {
                items = this.items.filter(item => item.complete)
            } else if (this.current === 'ongoing') {
                items = this.items.filter(item => !item.complete)
            } else {
                items = this.items;
            }
            return items.filter(item => {
                return item.nodeDescription.id.match(this.search);
            })
        }
    },
    created(){
        let user = auth.currentUser
        db.collection('users').where('id', '==', user.uid).get().then(snapshot => {
            snapshot.forEach(doc => {
                this.user = doc.data()
            })
        }).then(() => {
            db.collection('items').orderBy('timestamp', 'asc').get().then(snapshot => {
                snapshot.forEach(doc => {
                    if(doc.data().user.alias == this.user.alias) {
                        let item = doc.data();
                        item.id = doc.id;
                        this.items.push(item);
                    }
                })
            })
        })
    }
}
</script>

<style scoped>
.item.Actor {
    border-left: 4px solid #F48FB1;
}
.item.Event {
    border-left: 4px solid #9FA8DA;
}
.item.Place {
    border-left: 4px solid #CE93D8;
}
.item.Record {
    border-left: 4px solid #80CBC4;
}
.item.Object {
    border-left: 4px solid #BCAAA4;
}
.item.Concept {
    border-left: 4px solid #FFF59D;
}
.item.Story {
    border-left: 4px solid #CE93D8;
}
.item.Food {
    border-left: 4px solid #C5E1A5;
}
</style>